$(document).ready(function () {
  function update_step_numbers() {
    var visible_steps = $("span.step-number:visible");
    visible_steps.each(function (index, step) {
      // 0 indexed
      $(step).html(index + 1);
    });
  }

  // reveal parts of the page as options are chosen
  var reveal_buttons = $(".show-hidden");
  reveal_buttons.each(function (index, button) {
    var show_target = $(button).data("show");
    var hide_target = $(button).data("hide");
    $(button).on("click", function (e) {
      $(hide_target).addClass("hide");
      $(show_target).removeClass("hide");
      $(show_target).parents(".hide").removeClass("hide");
      update_step_numbers();
    });
  });

  var chosen_coffee_forms = $(".chosen-coffee--personalise > form");

  chosen_coffee_forms.each(function (index, form) {
    var variant = $('select[name="id"]', form);
    var quantity = $('select[name="quantity"]', form);
    var selling_plan = $('select[name="selling_plan"]', form);
    var price = $("span.price-amount", form);

    // we want to change the price when any of the selections change
    variant
      .add(quantity)
      .add(selling_plan)
      .on("change", function () {
        var variant_id = variant.val();
        var selling_plan_id = selling_plan.val();

        var selected_variant = $("option:selected", variant);
        var unit_price = selected_variant.attr(
          "data-price-per-delivery-" + selling_plan_id
        );

        var currency_symbol = price.data("currency-symbol");
        if (typeof unit_price !== "undefined") {
          var total_price = (unit_price / 100) * quantity.val();
          var formatted_price = total_price
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        } else {
          var formatted_price = price.data("fallback-price");
        }
        price.html(currency_symbol + formatted_price);
      });
  });

  $(".smoothslide").click(function (event) {
    // On-page links
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $("html, body").animate(
        {
          scrollTop: target.offset().top - 75,
        },
        1000,
        function () {
          // Callback after animation
          // Must change focus!
          // var $target = $(target);
          // $target.focus();
          // if ($target.is(":focus")) { // Checking if the target was focused
          //   return false;
          // } else {
          //   $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
          //   $target.focus(); // Set focus again
          // };
        }
      );
    }
  });

  // show passenger if someone clicked from the blog page
  var urls = ["/blogs/passenger", "/pages/passenger-subscription"];
  var matched = false;
  for (var url of urls) {
    if (document.referrer.indexOf(url) > -1) {
      matched = true;
      break;
    }
  }

  if (matched) {
    //$("#step1").removeClass("hide");
    $("#step2beans").removeClass("hide");
    $("#step4").removeClass("hide");
    var passenger = $("#chosen-coffee-" + imm_product_id);
    passenger.removeClass("hide");
    var step4 = $("#step4");
    $("html, body").animate(
      {
        scrollTop: step4.offset().top - 50,
      },
      1000
    );
  }
});
